import React from 'react';
import PropTypes from 'prop-types';

// Config
import { crudConfig as crudConfigLists } from '../../../conf/lists';

// Components
import { MaterialIcon } from '../../../../components/MaterialIcon';
import { Dialog } from '../../../../components/Dialog';
import { DialogHeader } from '../../../../components/DialogHeader';
import { DialogBody } from '../../../../components/DialogBody';
import { DialogFooter } from '../../../../components/DialogFooter';
import { Button } from '../../../../components/Button';
import FeedbackCard from '../../../../components/FeedbackCard';

// Hooks
import { useDeleteList } from '../../api/hooks/useDeleteList';

export const DeleteList = ({ data, closeDialog, sessionToken }) => {
    const [wasSuccessful, setWasSuccessful] = React.useState(false);
    const deleteList = useDeleteList({
        crudConfig: crudConfigLists,
        sessionToken,
        onSuccessCb: () => {
            setFatalError(null);
            setWasSuccessful(true);
            setTimeout(() => {
                CloseDialog();
            }, 500);
        },
        onErrorCb: (e) => {
            setFatalError(e);
            setWasSuccessful(false);
        }
    });
    const [fatalError, setFatalError] = React.useState(null);
    const [deleteData, setDeleteData] = React.useState();

    React.useEffect(() => {
        if (!deleteData) {
            setDeleteData(data);
        }
    }, [data]);

    const CloseDialog = () => {
        return typeof closeDialog === 'function' ? closeDialog() : null;
    };

    const Delete = () => {
        deleteList.mutate(data.listId);
    };

    return (
        <div style={{ height: `30rem` }}>
            <Dialog close={CloseDialog} size="md" visible id="list-manager-delete">
                <DialogHeader close={CloseDialog}>{`Delete ${deleteData?.name} - ${deleteData?.code}`}</DialogHeader>
                <DialogBody>
                    Are you sure you wish to delete this list?
                    {fatalError != null && (
                        <FeedbackCard
                            intent={'danger'}
                            feedback={{
                                heading: `An error has occurred.`,
                                message: `Please wait a few moments before trying your request
        again.`
                            }}
                            details={fatalError}
                        />
                    )}
                </DialogBody>
                <DialogFooter>
                    {deleteList.isLoading && <div style={{ marginRight: '0.5rem' }}>Loading...</div>}
                    {!deleteList.isLoading && wasSuccessful && (
                        <div style={{ marginRight: '0.5rem' }}>
                            <MaterialIcon icon={'done_outline'} color={'#04846D'} />
                        </div>
                    )}
                    <Button appearance="primary" text onClick={Delete} disabled={deleteList.isLoading}>
                        Delete
                    </Button>
                    <Button appearance="secondary" text onClick={CloseDialog}>
                        Cancel
                    </Button>
                </DialogFooter>
            </Dialog>
        </div>
    );
};

DeleteList.propTypes = {
    sessionToken: PropTypes.string.isRequired,
    data: PropTypes.object,
    closeDialog: PropTypes.func.isRequired
};

export default DeleteList;
